import type {
  FlowObserverPanelState,
  FlowObserverPanelTabRuntimeState,
  PanelMode,
  FloatingPanelGeometry,
} from '../types/panel.types.js';

export const PANEL_STORAGE_KEY = 'bizfirst.flow-observer.panel.v2';

type PersistedTabState = Pick<FlowObserverPanelTabRuntimeState, 'id' | 'userState' | 'order'>;

interface PersistedPanelState {
  panelMode: PanelMode;
  dockedHeight: number;
  floatingGeometry: FloatingPanelGeometry;
  activeTabId: string | null;
  tabRuntimeStates: Record<string, PersistedTabState>;
}

export function savePanelState(state: Partial<FlowObserverPanelState>): void {
  try {
    const tabRuntimeStates: Record<string, PersistedTabState> = {};
    if (state.tabRuntimeStates) {
      for (const [id, tab] of Object.entries(state.tabRuntimeStates)) {
        tabRuntimeStates[id] = { id: tab.id, userState: tab.userState, order: tab.order };
      }
    }

    const persisted: Partial<PersistedPanelState> = {
      panelMode: state.panelMode,
      dockedHeight: state.dockedHeight,
      floatingGeometry: state.floatingGeometry,
      activeTabId: state.activeTabId,
      tabRuntimeStates,
    };
    localStorage.setItem(PANEL_STORAGE_KEY, JSON.stringify(persisted));
  } catch {
    // Storage quota or private mode — silently ignore
  }
}

export function loadPanelState(): Partial<PersistedPanelState> | null {
  try {
    const raw = localStorage.getItem(PANEL_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Partial<PersistedPanelState>;
  } catch {
    return null;
  }
}
